import { BulkProduceTypeEnum, type StorageKey } from "../../enums";
import type { TCompanyId } from "../../models";
import { isSomeEnum } from "../enum.helpers";
import { Log } from "../log.helpers";
import { localStorageHelpers } from "./storage.helpers";

const getBookingsProductionActionStorageKey = (
  companyId: TCompanyId,
): StorageKey => `${companyId}_bookingsProductionAction`;

/** Falls back to Produce when nothing is stored, or when a stored value is no longer a known option. */
export const getStoredBookingsProductionAction = (
  companyId: TCompanyId,
): BulkProduceTypeEnum => {
  const storedAction = localStorageHelpers.getItem<unknown>(
    getBookingsProductionActionStorageKey(companyId),
  );

  return isSomeEnum(BulkProduceTypeEnum)(storedAction)
    ? storedAction
    : BulkProduceTypeEnum.Produce;
};

export const storeBookingsProductionAction = ({
  companyId,
  action,
}: {
  companyId: TCompanyId;
  action: BulkProduceTypeEnum;
}): void => {
  try {
    localStorageHelpers.setItem(
      getBookingsProductionActionStorageKey(companyId),
      action,
    );
  } catch (error) {
    // Private browsing, a full quota — production goes on, the choice is just not remembered.
    Log.warn("Could not persist the bookings production action", error);
  }
};
